import http from '@/http'

const PATH = '/customers'

function getPath (customerId, number) {
    return `${PATH}/${customerId}/numbers/${number}/billing`
}

export default {
    async listBillings ({customerId, number, params}) {
        try {
            const response = await http.get(getPath(customerId, number), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}
